import { fetchJson } from './../core/ajax-json.js';

function calculateCheckNumber(peselNumber) {
	const a = parseInt(peselNumber.substring(0, 1), 10);
	const b = parseInt(peselNumber.substring(1, 2), 10);
	const c = parseInt(peselNumber.substring(2, 3), 10);
	const d = parseInt(peselNumber.substring(3, 4), 10);
	const e = parseInt(peselNumber.substring(4, 5), 10);
	const f = parseInt(peselNumber.substring(5, 6), 10);
	const g = parseInt(peselNumber.substring(6, 7), 10);
	const h = parseInt(peselNumber.substring(7, 8), 10);
	const i = parseInt(peselNumber.substring(8, 9), 10);
	const j = parseInt(peselNumber.substring(9, 10), 10);


	const sum = (a * 1) + (b * 3) + (c * 7) + (d * 9) + (e * 1) + (f * 3) + (g * 7) + (h * 9) + (i * 1) + (j * 3);
	const calculatedChecksum = sum % 10;
	return (10 - calculatedChecksum) % 10;
}

function belongsInArray(elem, array) {
	for (let x = 0; x <= array.length; x += 1) {
		if (array[x] === elem) {
			return true;
		}
	}
	return false;
}


function isValid(peselNumber) {
	if (peselNumber.length !== 11) {
		return false;
	}

	if (peselNumber % 1 !== 0) {
		return false;
	}
	const year = parseInt(peselNumber.substring(0, 2), 10);
	const monthRaw = parseInt(peselNumber.substring(2, 4), 10);
	const month = monthRaw % 20;
	const bigMonth = [1, 3, 5, 7, 8, 10, 12];
	const smallMonth = [4, 6, 9, 11];
	const february = [2];
	const day = peselNumber.substring(4, 6);

	if (belongsInArray(month, bigMonth)) {
		if (parseInt(day, 10) > 31 || parseInt(day, 10) < 1) {
			return false;
		}
	} else if (belongsInArray(month, smallMonth)) {
		if (parseInt(day, 10) > 30 || parseInt(day, 10) < 1) {
			return false;
		}
	} else if (belongsInArray(month, february)) {
		if (year % 100 === 0 && monthRaw === 22) {
			if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
				return false;
			}
		} else if (year % 100 !== 0 && year % 4 === 0) {
			if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
				return false;
			}
		} else if (parseInt(day, 10) > 28 || parseInt(day, 10) < 1) {
			return false;
		}
	} else {
		return false;
	}

	const sumCheck = peselNumber.substring(10);
	const calculatedChecksum = calculateCheckNumber(peselNumber);
	if (calculatedChecksum !== parseInt(sumCheck, 10)) {
		return false;
	}
	return true;
}

function checkPeselFromServer(peselNumber) {
	return fetchJson(`/rest/register/personalnumber/pesel/${peselNumber}`);
}

function show() {
	return fetchJson('/pzbuk');
}

export default {
	checkPeselFromServer,
	isValid,
	show
};



// WEBPACK FOOTER //
// ./mobile-core/src/register/pesel.js